import { AppBar, Tab } from '@dls/react-core';
import React from 'react';
import { Outlet, useMatch, useNavigate, useOutletContext } from 'react-router-dom';
import { BackNavigationHeader } from '../../../components/styled/back-navigation-header';
import {
  PageWrapper,
  StyledPageTabBar,
  StyledPaperShadow,
  StyledTabWrapper,
} from '../../../components/styled/styles';
import { RoutePaths } from '../../../routes/main-routes';
import { Study } from '../../../api/studykit';
import { useAuthorization } from '../../../context/authorization';

type EditStudyContext = {
  study: Study;
  title: string;
};

export const EditStudy = () => {
  const match = useMatch(`/${RoutePaths.Studies}/:studyId/edit/:tab`);
  const tab = match?.params.tab;
  const studyId = match?.params.studyId;
  const navigate = useNavigate();
  const { hasPermission } = useAuthorization();

  const EDIT_TABS = [
    { tab: 'information', label: 'Study Information' },
    // { tab: 'devices', label: 'Study Devices' },
    {
      tab: 'configurations',
      label: 'Configurations',
      disabled: !hasPermission('Configurations.Read'),
    },
    { tab: 'users', label: 'Users', disabled: !hasPermission('Users.Read') },
  ];

  return (
    <PageWrapper>
      <BackNavigationHeader navigateTo={`/${RoutePaths.Studies}/${studyId}`} title={'View Study'} />
      <StyledPaperShadow>
        <AppBar position="static">
          <StyledPageTabBar value={tab} className="disabled-tabs">
            {EDIT_TABS.map((s, i) => (
              <Tab
                value={s.tab}
                style={{ width: `12rem` }}
                key={i}
                label={s.label}
                className="navigation"
                onClick={() => navigate(s.tab)}
                disabled={s.disabled}
              />
            ))}
          </StyledPageTabBar>
        </AppBar>
        <StyledTabWrapper>
          <Outlet />
        </StyledTabWrapper>
      </StyledPaperShadow>
    </PageWrapper>
  );
};

export const useEditContext = () => {
  return useOutletContext<EditStudyContext>();
};
